import React from 'react';

const EmailVerificationPage = ({ status, message, onLogin, onBack }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-800">
      <div className="bg-black py-2 px-4">
        <div className="max-w-7xl mx-auto flex items-center">
          <img src="/logo-v4.png" alt="Logo" className="h-20 w-20 object-contain" />
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 p-4">
        <div className="w-full max-w-md">
          <div className="bg-white dark:bg-gray-800/90 backdrop-blur-xl rounded-3xl shadow-2xl shadow-[#FF6600]/10 p-8 border border-white/50 text-center" data-testid="email-verification-card">
            {status === 'verifying' && (
              <>
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <div className="w-8 h-8 border-3 border-[#FF6600] border-t-transparent rounded-full animate-spin"></div>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Verifying Email...</h2>
                <p className="text-gray-500 dark:text-gray-400">Please wait while we verify your email address.</p>
              </>
            )}
            {status === 'success' && (
              <>
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Email Verified!</h2>
                <p className="text-gray-500 dark:text-gray-400 mb-6">{message}</p>
                <button
                  data-testid="continue-to-login-btn"
                  onClick={onLogin}
                  className="w-full py-4 bg-gradient-to-r from-[#FF6600] to-[#FF8533] text-white font-bold text-lg rounded-xl hover:shadow-lg transition-all"
                >
                  Continue to Login
                </button>
              </>
            )}
            {status === 'error' && (
              <>
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Verification Failed</h2>
                <p className="text-gray-500 dark:text-gray-400 mb-6">{message}</p>
                <button
                  onClick={onBack}
                  className="w-full py-4 bg-gradient-to-r from-[#FF6600] to-[#FF8533] text-white font-bold text-lg rounded-xl hover:shadow-lg transition-all"
                >
                  Back to Home
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationPage;
